// © Microsoft Corporation. All rights reserved.

import { registerResetCallback } from "@msnews/core";

/**
 * Experiences being tracked for milestone data updates. This normally includes all experience
 * types being tracked under various trackers such as DOM, Visual Readiness & Deferral trackers.
 * It is used to prevent firing of certain general milestone events from base classes so that
 * we're not wasting CPU cycles processing unnecessary redux actions.
 */
let trackingExperiences: { [experienceType: string]: boolean } = {};

/**
 * Helper to check whether we're tracking milestone events for the given experience and the event type
 */
export function shouldTrackExperience(experienceType: string, shouldTrack?: boolean): boolean {
    return shouldTrack != null
        ? trackingExperiences[experienceType] = shouldTrack
        : trackingExperiences[experienceType];
}

/**
 * Register a callback to reset the trackingExperiences.
 * The callback is registered once when the module is loaded and invoked once on the server side at the beginning of each request.
 */
registerResetCallback(() => {
    trackingExperiences = {};
});
